import { createSuffixTypes } from './createAsyncSagaAction';
import { Reducer, ReducerMeta } from 'redux-actions';

interface ListenerMap<State, Payload, Meta> {
  onCancel?: ReducerMeta<State, Payload, Meta>;
  onSuccess?: ReducerMeta<State, Payload, Meta>;
  onFailure?: ReducerMeta<State, Payload, Meta>;
  onRequest?: ReducerMeta<State, Payload, Meta>;
}

export function createAsyncSagaReducerMap<State, Payload = any, Meta = any>(
  type: string,
  listenerMap: ListenerMap<State, Payload, Meta>
): { [key: string]: Reducer<State, Payload> } {
  const types = createSuffixTypes(type);

  return {
    [types.cancel]: listenerMap.onCancel,
    [types.request]: listenerMap.onRequest,
    [types.success]: listenerMap.onSuccess,
    [types.failure]: listenerMap.onFailure
  } as any;
}
